import type { BlogBlock } from '~/types/blog'
import { articlePlainText } from './plainText'

const WORDS_PER_MINUTE = 180

export function countWords(text: string): number {
  return text
    .trim()
    .split(/[\s\u200c]+/)
    .filter(Boolean).length
}

export function readingMinutesFromText(text: string): number {
  const words = countWords(text)
  return Math.max(1, Math.ceil(words / WORDS_PER_MINUTE))
}

export function readingMinutesFromBlocks(blocks: BlogBlock[]): number {
  return readingMinutesFromText(articlePlainText(blocks))
}
